import { render, staticRenderFns } from "./OpsiyonDuzenle.vue?vue&type=template&id=708fcae0&scoped=true&"
import script from "./OpsiyonDuzenle.vue?vue&type=script&lang=js&"
export * from "./OpsiyonDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./OpsiyonDuzenle.vue?vue&type=style&index=0&id=708fcae0&scoped=true&lang=css&"
import style1 from "./OpsiyonDuzenle.vue?vue&type=style&index=1&id=708fcae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708fcae0",
  null
  
)

export default component.exports